/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PriReassignmentDto
 */
export interface PriReassignmentDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof PriReassignmentDto
     */
    pris?: Array<string> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof PriReassignmentDto
     */
    idsApprenant?: Array<number> | null;
    /**
     * 
     * @type {number}
     * @memberof PriReassignmentDto
     */
    newIdPri?: number | null;
}

/**
 * Check if a given object implements the PriReassignmentDto interface.
 */
export function instanceOfPriReassignmentDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PriReassignmentDtoFromJSON(json: any): PriReassignmentDto {
    return PriReassignmentDtoFromJSONTyped(json, false);
}

export function PriReassignmentDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PriReassignmentDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'pris': !exists(json, 'pris') ? undefined : json['pris'],
        'idsApprenant': !exists(json, 'idsApprenant') ? undefined : json['idsApprenant'],
        'newIdPri': !exists(json, 'newIdPri') ? undefined : json['newIdPri'],
    };
}

export function PriReassignmentDtoToJSON(value?: PriReassignmentDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'pris': value.pris,
        'idsApprenant': value.idsApprenant,
        'newIdPri': value.newIdPri,
    };
}

